import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const jobCardList = createAsyncThunk('jobCard/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `job_card`,
            params: {
                ...(data?.pageSize != null && { pageSize: data.pageSize }),
                ...(data?.currentPage != null && { pageNo: data.currentPage }),
                'search': data?.search,
                'premise_id': data?.premise_id,
                'zone_id': data?.zone_id,
                'level_id': data?.level_id,
                'asset_id': data?.asset_id,
                'asset_inward_id': data?.asset_inward_id,
                'status': data?.status,
                'fDate': data?.date_from && moment(data?.date_from, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                'tDate': data?.date_to && moment(data?.date_to, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                'schedule_date': data?.schedule_date && moment(data?.schedule_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateJobCardStatus = createAsyncThunk('jobCard/updateStatus', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'job_card',
            data: {
                "job_card_id": data?.job_card_id,
                "status": data?.status,
                "description": data?.description || '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const jobCard = createSlice({
    name: 'jobCard',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(jobCardList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
    }
})

export default jobCard.reducer;